import Base from "./base";

export default class DeltaPay extends Base {
	makeExternalPayment(newStep) {
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(this.state.stake),
				claimsBonus: false,
				currency: this.state.selectedCurrency,
				method: "Deposit",
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(this.state.stake),
				claimsBonus: true,
				bonusId: bonusId,
				currency: this.state.selectedCurrency,
				method: "Deposit",
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}
}
